import { render } from "./TarifasComponent.vue?vue&type=template&id=070530ee"
import script from "./TarifasComponent.vue?vue&type=script&lang=js"
export * from "./TarifasComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__